import { createSlice } from "@reduxjs/toolkit";
import deactivateUserApi from "@custom/rtk-apis/user/deactivateUser";

const initialState = {
  status:"",
  result:{},
  message:"",
  loading:false,
  error:""
};

const deactivateUserSlice = createSlice({
  name: "deactivateUserSlice",
  initialState,
  reducers: {
    closeDeactivateUserListModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deactivateUserApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deactivateUserApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.message = payload.message;
      })
      .addCase(deactivateUserApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deactivateUserSlice.reducer;
export const { closeDeactivateUserListModal } = deactivateUserSlice.actions;
